import { render, staticRenderFns } from "./AsignarCapacitaciones.vue?vue&type=template&id=5b052fff"
import script from "./AsignarCapacitaciones.vue?vue&type=script&lang=js"
export * from "./AsignarCapacitaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports